import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { IBoardHistoryAppointmentDockTimeZoneConfiguration } from "../../../../../../../../../models/masterAppointment/IAppointmentBoard";
import { useAppDispatch } from "../../../../../../../../../redux/hooks";
import { setShowPopUpAppointmentDockTimeZoneConfiguration } from "../../../../../../../../../redux/reducers/masterAppointment/appointmentBoard/appointmentDockTimeZoneConfiguration/form";
import { ButtonPrimaryInverseWithBorder } from "../../../../../../../../common/buttons/buttons";
import { TitleH5 } from "../../../../../../../../common/titles/titles";
import { MasterCertificateTypeFormStyle } from "./containerStyle.jss";
import { MasterBoardHistoryAppointmentDockTimeZoneConfigurationControllerForm } from "./controller/controller";
import { MasterBoardHistoryAppointmentDockTimeZoneConfigurationList } from "./list/list";
import { ColorType } from "../../../../../../../../../common/enum/ColorType";
import { PopUpCodes } from "../../../../../../../../../common/enum/PopUpCodes";

interface IMasterBoardHistoryAppointmentDockTimeZoneConfigurationProps {
    list: IBoardHistoryAppointmentDockTimeZoneConfiguration[];
}

export const MasterBoardHistoryAppointmentDockTimeZoneConfigurationContainer: React.FC<
    IMasterBoardHistoryAppointmentDockTimeZoneConfigurationProps
> = ({ list }) => {
    const { t } = useTranslation("common", { keyPrefix: "MASTER_APPOINTMENT.APPOINTMENT_BOARD.TITLES" });
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const style = MasterCertificateTypeFormStyle({ theme });
    return (
        <div className={style.container}>
            <div className={style.header}>
                <TitleH5
                    title={t("APPOINTMENT_DOCK_TIME_ZONE_CONFIGURATION")}
                    bold={true}
                    color={ColorType.primary}
                />
                <ButtonPrimaryInverseWithBorder
                    handleClick={() => {
                        dispatch(setShowPopUpAppointmentDockTimeZoneConfiguration(PopUpCodes.CREATE));
                    }}
                    title={`+ ${t("ADD")}`}
                />
            </div>

            <MasterBoardHistoryAppointmentDockTimeZoneConfigurationList list={list} />
            <MasterBoardHistoryAppointmentDockTimeZoneConfigurationControllerForm />
        </div>
    );
};
